Vue.component('faqs-table', () => import(/* webpackChunkName: "faqs-table" */ '@modulesPages/FAQ/Resources/assets/js/Tables/FAQsTable'))

Vue.component('faqs-form', () => import(/* webpackChunkName: "faqs-form" */ '@modulesPages/FAQ/Resources/assets/js/Forms/FAQs/FAQsForm'))

Vue.component('faqs-section', () => import(/* webpackChunkName: "faqs-section" */ '@modulesPages/FAQ/Resources/assets/js/Sections/FAQsSection'))
Vue.component('faq-section', () => import(/* webpackChunkName: "faq-section" */ '@modulesPages/FAQ/Resources/assets/js/Sections/FAQSection'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\FAQ\\Entities\\FAQ': 'Pregunta/respuesta frecuente',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\FAQ\\Entities\\FAQ': 'faqs',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'FAQs': 'Modules\\FAQ\\Entities\\FAQ',
	}	
}